/* eslint-disable no-unused-vars */
import images from "../../assets/images/assets";
// import cards from "../../assets/images/cards/cards";
import Title from "../SmallComponents/Title";
import NewsletterBox from "./NewsletterBox";
import GlobeVisualization from "../VisualizationComponents/GlobeVisualization";

// Sample customer data - replace with your actual customer data
import { customerData } from "../VisualizationComponents/globalData";

const StorySection = () => {
  return (
    <div className="mb-28">
      {/* Title */}
      <Title text1="Our" text2="Story" />

      {/* Story */}
      <div className="my-10 flex flex-col md:flex-row md:gap-8 gap-16 lg:gap-16 md:items-center lg:px-10 lg:justify-center">
        {/* Story-Image */}
        <div
          style={{ backgroundImage: `url(${images.story_img})` }}
          className="bg-zinc-50 h-[430px] lg:h-[480px] 2xl:h-[540px] outline outline-rose-400 overflow-clip rounded-t-full md:w-1/2 lg:w-1/3 z-[99] bg-cover bg-center saturate-150"
        >
          <img className="w-full lg:w-[450px]" src="#" alt="image" />
        </div>

        {/* STORY */}
        <div className="flex flex-col justify-center gap-6 md:w-2/4 text-gray-600">
          <p className="montserrat">
            <span className="font-semibold"> itsallaboutcards</span> was born
            out of a deep passion for creating meaningful connections through
            beautiful stationery. Founded in 2020, we set out to revolutionize
            the way people celebrate life&#39;s special moments by offering
            unique, handcrafted cards that tell stories and capture emotions in
            ways that digital messages simply cannot match.
          </p>
          <p className="montserrat">
            Since our inception, we have worked tirelessly to source the finest
            materials and collaborate with talented artists to create cards that
            are not just invitations or greetings, but treasured keepsakes that
            recipients will want to hold onto for years to come. Our dedication
            to quality and attention to detail sets us apart.
          </p>
          <b className="text-prime-red playfair-display text-xl md:text-2xl lg:text-3xl italic">
            Our Mission
          </b>
          <p className="montserrat">
            Our mission at{" "}
            <span className="font-semibold"> itsallaboutcards</span> is to
            empower customers with personalized, high-quality cards that makes
            every special occasion truly memorable. We strive to blend
            traditional craftsmanship with modern designs, ensuring each card
            becomes a cherished keepsake that captures life&#39;s most precious
            moments.
          </p>
        </div>
      </div>

      {/* 🚩 Global Reach Visualization */}
      <div className="my-20">
        {/* Title */}
        <Title text1="Our" text2="Global Reach" />
        <div className="h-[500px] w-full mt-8 bg-[#000000] overflow-scroll flex justify-center items-center cursor-pointer">
          <GlobeVisualization
            data={customerData}
            backgroundColor="#000000"
            rotationSpeed={0.25}
            autoRotate={true}
            onCountryClick={(point) => {
              // console.log("Clicked on:", point);
            }}
            style={{
              borderRadius: "20px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              width: "fit-content",
            }}
          />
        </div>
      </div>

      <div className="text-xl py-4">
        {/* Title */}
        <Title text1="Why" text2="Choose Us ?" />
        {/* Features */}
      </div>
      <div className="flex flex-col lg:flex-row gap-12 lg:gap-6 text-sm mb-20 md:px-20 lg:px-0 2xl:gap-10 2xl:p-5">
        {/* 1 */}
        <div className="border animate-border border-zinc-400/80 text-zinc-800 px-10 md:px-10 py-8 sm:py-20 flex flex-col gap-5 rounded-lg rounded-tl-[50px] cursor-pointer hover:bg-zinc-900 hover:text-zinc-100 hover:-translate-y-3 transition2">
          <b className="playfair-display italic text-lg lg:text-2xl">
            Quality Assurance:
          </b>
          <p className="montserrat">
            We meticulously craft each card using premium materials and expert
            techniques. Our rigorous quality control ensures every product meets
            the highest standards of excellence, from paper selection to final
            printing and packaging.
          </p>
        </div>

        {/* 2 */}
        <div className="border animate-border border-zinc-400/80 text-zinc-800 px-10 md:px-10 py-8 sm:py-20 flex flex-col gap-5 rounded-lg rounded-br-[50px] rounded-tl-[50px] cursor-pointer hover:bg-prime-red hover:text-zinc-100 hover:-translate-y-3 transition2">
          <b className="playfair-display italic text-lg lg:text-2xl">
            Convenience:
          </b>
          <p className="montserrat">
            Our user-friendly website makes browsing and ordering effortless.
            With detailed customization options and real-time previews, you can
            easily create the perfect card from the comfort of your home. Fast
            shipping ensures timely delivery.
          </p>
        </div>

        {/* 3 */}
        <div className="border animate-border border-zinc-400/80 text-zinc-800 px-10 md:px-10 py-8 sm:py-20 flex flex-col gap-5 rounded-lg rounded-tl-[50px] rounded-bl-[50px] cursor-pointer hover:bg-zinc-900 hover:text-zinc-100 hover:-translate-y-3 transition2">
          <b className="playfair-display italic text-lg lg:text-2xl">
            Exceptional Customer Service:
          </b>
          <p className="montserrat">
            Our dedicated team of stationery experts is available to assist you
            throughout your journey. From design advice to order tracking, we
            ensure a smooth experience and complete satisfaction with every
            purchase. Your celebration is our priority.
          </p>
        </div>
      </div>

      {/* CTA */}
      <NewsletterBox />
    </div>
  );
};

export default StorySection;
